<template>
  <div v-if="stats" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Card 1: Total Movimientos -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Movimientos</span>
        <div class="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-lg">
          <i class="fa fa-boxes" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-gray-900">{{ formatNumber(stats.total_inventories ?? 0) }}</p>
        <p class="text-xs text-gray-500 mt-1 flex items-center gap-1.5">
          <span class="text-emerald-600 font-semibold">{{ stats.processed_count ?? 0 }} procesados</span>
          <span>•</span>
          <span class="text-amber-600 font-semibold">{{ stats.pending_requests ?? 0 }} solicitudes</span>
        </p>
      </div>
    </div>

    <!-- Card 2: Unidades Ingresadas -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Unidades Ingresadas</span>
        <div class="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-lg">
          <i class="fa fa-cubes" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-emerald-600">{{ formatNumber(stats.total_units ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">
          Este mes: <strong class="text-gray-700 font-semibold">{{ formatNumber(stats.this_month_units ?? 0) }} unds</strong>
        </p>
      </div>
    </div>

    <!-- Card 3: Solicitudes Pendientes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Solicitudes Pendientes</span>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-lg">
          <i class="fa fa-clock" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-amber-600">{{ stats.pending_requests ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">
          Pendientes por procesar / aprobar
        </p>
      </div>
    </div>

    <!-- Card 4: Movimientos del Mes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Movimientos del Mes</span>
        <div class="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-lg">
          <i class="fa fa-calendar-alt" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-purple-600">{{ stats.this_month_count ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">
          Lotes registrados este mes
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryStats',

  props: {
    stats: {
      type: Object,
      default: () => ({
        total_inventories: 0,
        total_units: 0,
        pending_requests: 0,
        processed_count: 0,
        this_month_count: 0,
        this_month_units: 0,
      }),
    },
  },

  methods: {
    formatNumber(val) {
      const num = parseFloat(val) || 0
      return num.toLocaleString('es-VE', { maximumFractionDigits: 2 })
    },
  },
}
</script>
